"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reserve = exports.Liabilities = exports.LoanTapeField = exports.ReceivableAdvanceRate = exports.Reporting = exports.PortfolioCovenant = exports.GlobalRecurringDate = exports.FinancialCovenant = exports.ConcentrationLimit = exports.DeliverablePropertyDEPRECATED = void 0;
const Notifications = __importStar(require("../Notifications"));
var DeliverablePropertyDEPRECATED;
(function (DeliverablePropertyDEPRECATED) {
    // @jendevelops TODO: add in slack notification
    DeliverablePropertyDEPRECATED.PreUploadNotificationTypes = [
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyReminder,
        Notifications.BorrowerEmailType.deliverablesResponsiblePartyStatusUpdate,
    ];
    DeliverablePropertyDEPRECATED.PostUploadNotificationTypes = [
        Notifications.BorrowerEmailType
            .deliverablesResponsiblePartySubmitSubmission,
    ];
})(DeliverablePropertyDEPRECATED = exports.DeliverablePropertyDEPRECATED || (exports.DeliverablePropertyDEPRECATED = {}));
/**
 * ============= CONCENTRATION LIMIT =============
 */
var ConcentrationLimit;
(function (ConcentrationLimit) {
    /**
     * ============= VALUE CONFIG =============
     */
    let Value;
    (function (Value) {
        // for normalizing a number or currency type to a percentage type in standard calculation
        Value.ValueTypeIterable = [
            'currency',
            'number',
            'percentage',
        ];
    })(Value = ConcentrationLimit.Value || (ConcentrationLimit.Value = {}));
    let Calculation;
    (function (Calculation) {
        Calculation.DeclarativeConfigIterable = [
            'weightedAverage',
            'standard',
            'exposureByGroup',
        ];
        Calculation.SourceConfigIterable = [
            'pointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.ResolvedConfigIterable = [
            'resolvedPointer',
            ...Calculation.DeclarativeConfigIterable,
        ];
        Calculation.LimitTypeIterable = ['min', 'max'];
        let Filters;
        (function (Filters) {
            Filters.OrderByOperatorIterable = ['asc', 'desc'];
            Filters.InListConfigIterable = ['inList', 'notInList'];
            Filters.EqualOperatorIterable = ['equals', 'notEqual'];
            Filters.CompareOperatorIterable = [
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
            ];
            Filters.OperationTypeIterable = [
                'orderBy',
                'orderBySum',
                'notEqual',
                'equals',
                'lessThan',
                'greaterThan',
                'greaterThanOrEqual',
                'lessThanOrEqual',
                'inList',
                'notInList',
            ];
        })(Filters = Calculation.Filters || (Calculation.Filters = {}));
        Calculation.WeightingIterable = [
            'eligibleExposureLessConcentrationKickout',
            'constant',
        ];
    })(Calculation = ConcentrationLimit.Calculation || (ConcentrationLimit.Calculation = {}));
})(ConcentrationLimit = exports.ConcentrationLimit || (exports.ConcentrationLimit = {}));
/**
 * ============= FINANCIAL COVENANT =============
 */
var FinancialCovenant;
(function (FinancialCovenant) {
    let PortfolioCovenantKey;
    (function (PortfolioCovenantKey) {
        // @portcov - temporarily living in financial covenant namespace until actual portfolio covenant tracking is built
        // move to own namespace when portfolio cov configs in admin is builts
        PortfolioCovenantKey["DefaultRate"] = "defaultRate";
        PortfolioCovenantKey["DelinquencyRatio"] = "delinquencyRatio";
        PortfolioCovenantKey["ExcessSpreadRatio"] = "excessSpreadRatio";
        PortfolioCovenantKey["PaymentRatio"] = "paymentRatio";
        PortfolioCovenantKey["ChargeOffRate"] = "chargeOffRate";
        PortfolioCovenantKey["CumulativeDefaultRate"] = "cumulativeDefaultRate";
    })(PortfolioCovenantKey = FinancialCovenant.PortfolioCovenantKey || (FinancialCovenant.PortfolioCovenantKey = {}));
    let FinancialCovenantKey;
    (function (FinancialCovenantKey) {
        FinancialCovenantKey["FixedChargeCoverageRatio"] = "fixedChargeCoverageRatio";
        FinancialCovenantKey["MaximumAdjustedQuarterlyOperatingExpense"] = "maximumAdjustedQuarterlyOperatingExpense";
        FinancialCovenantKey["MaximumCorporateLeverageRatio"] = "maximumCorporateLeverageRatio";
        FinancialCovenantKey["MaximumLeverageRatio"] = "maximumLeverageRatio";
        FinancialCovenantKey["MinimumAssetCoverage"] = "minimumAssetCoverage";
        FinancialCovenantKey["MinimumEnterpriseValue"] = "minimumEnterpriseValue";
        FinancialCovenantKey["MinimumInterestCoverageRatio"] = "minimumInterestCoverageRatio";
        FinancialCovenantKey["MaximumLoanToValueRatio"] = "maximumLoanToValueRatio";
        FinancialCovenantKey["MinimumLiquidity"] = "minimumLiquidity";
        FinancialCovenantKey["MinimumNonPerformingLoanReservesRatio"] = "minimumNonPerformingLoanReservesRatio";
        FinancialCovenantKey["MinimumOvercollateralization"] = "minimumOvercollateralization";
        FinancialCovenantKey["MinimumRunwayRatio"] = "minimumRunwayRatio";
        FinancialCovenantKey["MinimumTangibleNetWorth"] = "minimumTangibleNetWorth";
        FinancialCovenantKey["MinimumCompanyWideLoanToValueRatio"] = "minimumCompanyWideLoanToValueRatio";
        FinancialCovenantKey["MinimumThreeMonthAverageVintagePoolRecoveryRate"] = "minimumThreeMonthAverageVintagePoolRecoveryRate";
        FinancialCovenantKey["UnrestrictedCash"] = "unrestrictedCash";
        // @portcov - temporarily living in financial covenant namespace until actual portfolio covenant tracking is built
        // move to own namespace when portfolio cov configs in admin is builts
        FinancialCovenantKey["DefaultRate"] = "defaultRate";
        FinancialCovenantKey["DelinquencyRatio"] = "delinquencyRatio";
        FinancialCovenantKey["ExcessSpreadRatio"] = "excessSpreadRatio";
        FinancialCovenantKey["PaymentRatio"] = "paymentRatio";
        FinancialCovenantKey["ChargeOffRate"] = "chargeOffRate";
        FinancialCovenantKey["CumulativeDefaultRate"] = "cumulativeDefaultRate";
    })(FinancialCovenantKey = FinancialCovenant.FinancialCovenantKey || (FinancialCovenant.FinancialCovenantKey = {}));
    let LimitValueType;
    (function (LimitValueType) {
        LimitValueType["currency"] = "currency";
        LimitValueType["ratio"] = "ratio";
        LimitValueType["percentage"] = "percentage";
    })(LimitValueType = FinancialCovenant.LimitValueType || (FinancialCovenant.LimitValueType = {}));
    let LimitType;
    (function (LimitType) {
        LimitType["Min"] = "min";
        LimitType["Max"] = "max";
    })(LimitType = FinancialCovenant.LimitType || (FinancialCovenant.LimitType = {}));
    let CalculateMethod;
    (function (CalculateMethod) {
        CalculateMethod["XlsxParse"] = "xlsxParse";
    })(CalculateMethod = FinancialCovenant.CalculateMethod || (FinancialCovenant.CalculateMethod = {}));
})(FinancialCovenant = exports.FinancialCovenant || (exports.FinancialCovenant = {}));
/**
 * ============================================
 * ======    GLOBAL RECURRING DATE     ========
 * ============================================
 *
 * This set up is to represent configs that will help generate
 * dynamic date lists based on our recurring date mechanics.
 * Currently being used by PortCovs & Reporting Mechanics
 */
var GlobalRecurringDate;
(function (GlobalRecurringDate) {
    GlobalRecurringDate.SetupTypeIterable = ['static', 'relative'];
})(GlobalRecurringDate = exports.GlobalRecurringDate || (exports.GlobalRecurringDate = {}));
/**
 * Portfolio Covenants operate generically in the following manner:
 *
 * Queries (Athena and Postgres) have variables that are primitives.
 * There is a special runtime variable `triggerDate` that always injected into the variable list.
 *
 * These variables can be then used in formulas to determine what parameterized values should be passed to a query implementation.
 * A common pattern will be to have `triggerDate` variable passed to a formula to determine `startDate` of a query
 * ie. startDate is the first of day of the previous month relative to the triggerDate
 *
 * The resulting evaluation of the formulas are then passed as parameters to the query implementation.
 * Postgres queries will pass as params to a method as there may be additional application logic.
 * Athena params are simply bound to the query with `?` binding pattern.
 *
 * The results of the athena or pg query are then made available to the intermediate fields (formula) from futher evaluation.
 *
 * Athena results will be the first row of the resulting query, accessible by queryName.columnName in intermediate fields
 * ColumnNames are eagerly stored/validated in the config, unexpected column names are omitted in the response.
 *
 * Postgres results will resolve to singular primitive (application code wrapping the pg query will handle this), accessible by `name` in intermediate fields.
 *
 */
var PortfolioCovenant;
(function (PortfolioCovenant) {
    /**
     * ###### POSTGRES QUERY TYPES ######
     */
    PortfolioCovenant.PostgresQueryTypeIterable = [
        'principalBalanceDailyAverage',
        'principalBalancePointInTime',
        'tAccountsSum',
        'orgProvidedInput',
    ];
    PortfolioCovenant.RequiredIntermediateFieldIterable = [
        'triggerDate',
        'portfolioCovenantValue',
        'portfolioCovenantResult',
        'portfolioCovenantReportingDate',
    ];
})(PortfolioCovenant = exports.PortfolioCovenant || (exports.PortfolioCovenant = {}));
/**
 * ============================================
 * =============   REPORTING   ================
 * ============================================
 */
var Reporting;
(function (Reporting) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   DATA ACCESSOR   ************
        let DataAccessor;
        (function (DataAccessor) {
            DataAccessor.Methods = [
                'accruedLiabilities',
                'borrowingBaseMetrics',
                'fundingRequestMetrics',
                'orgProvidedInputs',
                'portfolioCovenantResults',
            ];
        })(DataAccessor = Inputs.DataAccessor || (Inputs.DataAccessor = {}));
    })(Inputs = Reporting.Inputs || (Reporting.Inputs = {}));
    // ========   OUTPUTS   ========
    let Outputs;
    (function (Outputs) {
        let Xlsx;
        (function (Xlsx) {
            Xlsx.DataOutputTypeIterable = [
                'dataCellObject',
                'fileInsertion',
            ];
            // *******************************
            // ***  File Insertion Config  ***
            // *******************************
            Xlsx.FileInsertionTypeIterable = [
                'rawMasterLoanTape',
                'rawAssignedLoanTape',
                'rawCovenantLoanTape',
                'rawRepaymentTape',
                'rawSupplementalTape',
                'generatedMasterLoanTape',
                'generatedAssignedLoanTape',
                'generatedCovenantLoanTape',
                'generatedRepaymentTape',
                'extendedResponseTape',
                'newlyAssignedExtendedResponseTape',
                'borrowingBaseReserve',
            ];
        })(Xlsx = Outputs.Xlsx || (Outputs.Xlsx = {}));
    })(Outputs = Reporting.Outputs || (Reporting.Outputs = {}));
    // ========   MAIN   ========
    Reporting.ReportTemplateFileTypeIterable = ['docx', 'xlsx'];
})(Reporting = exports.Reporting || (exports.Reporting = {}));
/**
 * ============= RECEIVABLE ADVANCE RATE CONFIG =============
 */
var ReceivableAdvanceRate;
(function (ReceivableAdvanceRate) {
    ReceivableAdvanceRate.Types = ['formula', 'tree'];
})(ReceivableAdvanceRate = exports.ReceivableAdvanceRate || (exports.ReceivableAdvanceRate = {}));
var LoanTapeField;
(function (LoanTapeField) {
    /**
     * ============= INTERMEDIATE CALCS =============
     */
    let IntermediateCalcs;
    (function (IntermediateCalcs) {
        // please ensure that this is subset of DataTapeField.Type
        IntermediateCalcs.ValidFieldTypes = [
            'integer',
            'optionalInteger',
            'string',
            'optionalString',
            'boolean',
            'optionalBoolean',
            'float',
            'optionalFloat',
            'date',
            'optionalDate',
            'percentage',
            'optionalPercentage',
        ];
    })(IntermediateCalcs = LoanTapeField.IntermediateCalcs || (LoanTapeField.IntermediateCalcs = {}));
})(LoanTapeField = exports.LoanTapeField || (exports.LoanTapeField = {}));
/**
 * Account Configuration (for accruals and reserve)
 */
var Liabilities;
(function (Liabilities) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   DATA ACCESSOR   ************
        let DataAccessor;
        (function (DataAccessor) {
            DataAccessor.Methods = [
                'facilityDataForReportingDate',
                'facilityDataForReportingDateRange',
            ];
        })(DataAccessor = Inputs.DataAccessor || (Inputs.DataAccessor = {}));
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = [
            'reportingDate',
            'accrualValue', // Output used for final accrual amount
        ];
    })(Inputs = Liabilities.Inputs || (Liabilities.Inputs = {}));
})(Liabilities = exports.Liabilities || (exports.Liabilities = {}));
var Reserve;
(function (Reserve) {
    // ========   INPUTS   ========
    let Inputs;
    (function (Inputs) {
        // ************   DATA ACCESSOR   ************
        let DataAccessor;
        (function (DataAccessor) {
            DataAccessor.Methods = [
                'accruedLiabilitiesForReportingDateRange',
                'facilityDataForReportingDate',
            ];
        })(DataAccessor = Inputs.DataAccessor || (Inputs.DataAccessor = {}));
        // ************   INTERMEDIATE FIELDS   ************
        Inputs.RequiredIntermediateFieldIterable = [
            'reportingDate',
            'collectionsCash',
            'borrowingBaseReserve',
            'collectionsReserve', // Expected output for cash reserve (collections)
        ];
    })(Inputs = Reserve.Inputs || (Reserve.Inputs = {}));
})(Reserve = exports.Reserve || (exports.Reserve = {}));
//# sourceMappingURL=Config.js.map